/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GenerateTitleRequestBody,
  GenerateTitleRequestBody$Outbound,
  GenerateTitleRequestBody$outboundSchema,
} from "../components/generatetitlerequestbody.js";

export type GenerateTitleSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GenerateTitleSecurityOption2 = {
  chatSessionsTokenHeaderGramChatSession: string;
};

export type GenerateTitleSecurity = {
  option1?: GenerateTitleSecurityOption1 | undefined;
  option2?: GenerateTitleSecurityOption2 | undefined;
};

export type GenerateTitleRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Chat Sessions token header
   */
  gramChatSession?: string | undefined;
  generateTitleRequestBody: GenerateTitleRequestBody;
};

/** @internal */
export type GenerateTitleSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GenerateTitleSecurityOption1$outboundSchema: z.ZodMiniType<
  GenerateTitleSecurityOption1$Outbound,
  GenerateTitleSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function generateTitleSecurityOption1ToJSON(
  generateTitleSecurityOption1: GenerateTitleSecurityOption1,
): string {
  return JSON.stringify(
    GenerateTitleSecurityOption1$outboundSchema.parse(
      generateTitleSecurityOption1,
    ),
  );
}

/** @internal */
export type GenerateTitleSecurityOption2$Outbound = {
  "chat_sessions_token_header_Gram-Chat-Session": string;
};

/** @internal */
export const GenerateTitleSecurityOption2$outboundSchema: z.ZodMiniType<
  GenerateTitleSecurityOption2$Outbound,
  GenerateTitleSecurityOption2
> = z.pipe(
  z.object({
    chatSessionsTokenHeaderGramChatSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      chatSessionsTokenHeaderGramChatSession:
        "chat_sessions_token_header_Gram-Chat-Session",
    });
  }),
);

export function generateTitleSecurityOption2ToJSON(
  generateTitleSecurityOption2: GenerateTitleSecurityOption2,
): string {
  return JSON.stringify(
    GenerateTitleSecurityOption2$outboundSchema.parse(
      generateTitleSecurityOption2,
    ),
  );
}

/** @internal */
export type GenerateTitleSecurity$Outbound = {
  Option1?: GenerateTitleSecurityOption1$Outbound | undefined;
  Option2?: GenerateTitleSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GenerateTitleSecurity$outboundSchema: z.ZodMiniType<
  GenerateTitleSecurity$Outbound,
  GenerateTitleSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GenerateTitleSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GenerateTitleSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function generateTitleSecurityToJSON(
  generateTitleSecurity: GenerateTitleSecurity,
): string {
  return JSON.stringify(
    GenerateTitleSecurity$outboundSchema.parse(generateTitleSecurity),
  );
}

/** @internal */
export type GenerateTitleRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Chat-Session"?: string | undefined;
  GenerateTitleRequestBody: GenerateTitleRequestBody$Outbound;
};

/** @internal */
export const GenerateTitleRequest$outboundSchema: z.ZodMiniType<
  GenerateTitleRequest$Outbound,
  GenerateTitleRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramChatSession: z.optional(z.string()),
    generateTitleRequestBody: GenerateTitleRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      gramChatSession: "Gram-Chat-Session",
      generateTitleRequestBody: "GenerateTitleRequestBody",
    });
  }),
);

export function generateTitleRequestToJSON(
  generateTitleRequest: GenerateTitleRequest,
): string {
  return JSON.stringify(
    GenerateTitleRequest$outboundSchema.parse(generateTitleRequest),
  );
}
